/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!***************************************************!*\
  !*** ./resources/scripts/sections/header/main.js ***!
  \***************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "header": () => (/* binding */ header)
/* harmony export */ });
var header = function header() {
  var $header = document.querySelector("header.header");
  if ($header) {
    var $body = document.querySelector("body");
    var $localizationSelectors = $header.querySelectorAll(".localization-selector");
    $localizationSelectors.forEach(function ($localizationSelector) {
      var $language = $localizationSelector.querySelector(".localization-selector__langauge");
      if ($language) {
        var $languageButton = $language.querySelector(".language__button");
        var $languageDropdown = $language.querySelector(".language__dropdown");
        var $languageForm = $languageDropdown.querySelector(".dropdown__form");
        var $formButtons = $languageForm.querySelectorAll(".form__button");
        var $formInput = $languageForm.querySelector(".form__input");
        $languageButton.addEventListener("click", function (event) {
          event.preventDefault();
          $languageDropdown.classList.remove("hidden");
        });
        $formButtons.forEach(function ($formButton) {
          $formButton.addEventListener("click", function (event) {
            event.preventDefault();
            $formInput.value = $formButton.dataset.value;
            $languageForm.submit();
          });
        });
        $body.addEventListener("click", function (event) {
          if (event.target != $languageButton && (event.target == $languageDropdown || !$languageDropdown.contains(event.target))) {
            $languageDropdown.classList.add("hidden");
          }
        });
      }
      var $location = $localizationSelector.querySelector(".localization-selector__location");
      if ($location) {
        var $locationButton = $location.querySelector(".location__button");
        var $locationDropdown = $location.querySelector(".location__dropdown");
        var $locationForm = $locationDropdown.querySelector(".dropdown__form");
        var _$formButtons = $locationForm.querySelectorAll(".form__button");
        var _$formInput = $locationForm.querySelector(".form__input");
        $locationButton.addEventListener("click", function (event) {
          event.preventDefault();
          $locationDropdown.classList.remove("hidden");
        });
        _$formButtons.forEach(function ($formButton) {
          $formButton.addEventListener("click", function (event) {
            event.preventDefault();
            _$formInput.value = $formButton.dataset.value;
            $locationForm.submit();
          });
        });
        $body.addEventListener("click", function (event) {
          if (event.target != $locationButton && (event.target == $locationDropdown || !$locationDropdown.contains(event.target))) {
            $locationDropdown.classList.add("hidden");
          }
        });
      }
    });
    var cart = window.Carbon.Cart;
    if (cart.useCartAside) {
      var $cartAsideBackground = document.querySelector(".cart-aside__background");
      var $cartAside = $cartAsideBackground.querySelector("aside.cart-aside");
      var $desktopCartLink = $header.querySelector(".navbar__desktop .header__cart-link");
      var $mobileCartLink = $header.querySelector(".navbar__mobile .header__cart-link");
      $desktopCartLink.addEventListener("click", function (event) {
        event.preventDefault();
        $body.classList.add("overflow-y-hidden");
        $cartAsideBackground.classList.remove("pointer-events-none");
        $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
        $cartAside.classList.remove("translate-x-full", "ponter-events-none", "hidden");
      });
      $mobileCartLink.addEventListener("click", function (event) {
        event.preventDefault();
        $body.classList.add("overflow-y-hidden");
        $cartAsideBackground.classList.remove("pointer-events-none");
        $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
        $cartAside.classList.remove("translate-x-full", "ponter-events-none", "hidden");
      });
    }
    var $menuDesktop = $header.querySelector(".menu__desktop");
    var $menuDesktopShop = $header.querySelector(".navbar__desktop .navbar__shop");
    if ($menuDesktop && $menuDesktopShop) {
      $menuDesktopShop.addEventListener("mouseover", function (event) {
        event.preventDefault();
        $menuDesktop.classList.remove("opacity-0", "pointer-events-none");
        $menuDesktop.classList.add("opacity-100", "pointer-events-auto");
      });
      $menuDesktop.addEventListener("mouseover", function (event) {
        if (event.target == $menuDesktop) {
          $menuDesktop.classList.remove("opacity-100", "pointer-events-auto");
          $menuDesktop.classList.add("opacity-0", "pointer-events-none");
        }
      });
    }
    var $navbarMobile = $header.querySelector("nav.navbar .navbar__mobile");
    var $navbarMobileButton = $navbarMobile.querySelector(".navbar__button");
    var $menuMobile = $header.querySelector(".menu__mobile");
    var $menuMobileButton = document.querySelector(".menu__button");
    var $menuMobileItems = $menuMobile.querySelectorAll(".menu__items .menu__item");
    $menuMobileItems.forEach(function ($menuMobileItem) {
      var $itemButton = $menuMobileItem.querySelector(".item__button");
      var $itemItems = $menuMobileItem.querySelector(".item__items");
      $itemButton.addEventListener("click", function (event) {
        event.preventDefault();
        var $buttonIcon = $itemButton.querySelector(".button__icon");
        $buttonIcon.classList.toggle("rotate-180");
        $itemItems.classList.toggle("hidden");
      });
    });
    $navbarMobileButton.addEventListener("click", function (event) {
      event.preventDefault();
      $body.classList.add("overflow-y-hidden");
      $menuMobile.classList.remove("hidden");
      $menuMobile.classList.add("block");
      $header.classList.add("mobile-menu-open");
      $navbarMobileButton.classList.add("hidden");
      $menuMobileButton.classList.remove("hidden");
    });
    $menuMobileButton.addEventListener("click", function (event) {
      event.preventDefault();
      $body.classList.remove("overflow-y-hidden");
      $menuMobile.classList.remove("block");
      $menuMobile.classList.add("hidden");
      $header.classList.remove("mobile-menu-open");
      $navbarMobileButton.classList.remove("hidden");
      $menuMobileButton.classList.add("hidden");
    });

    // Naked header functionality
    var hasNakedHeader = document.querySelector(".naked-header");
    if (hasNakedHeader) {
      // Function to toggle the 'naked-header' class based on scroll position
      var toggleHeaderStyle = function toggleHeaderStyle() {
        var scrollThreshold = 100;
        if (window.scrollY > scrollThreshold) {
          $header.classList.remove("naked-header-active"); // Remove the class when scrolled beyond the threshold
        } else {
          $header.classList.add("naked-header-active"); // Add the class when above the threshold
        }
      }; // Call on page load

      toggleHeaderStyle();

      // Call on scroll
      window.addEventListener("scroll", toggleHeaderStyle);
    }
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (header);
document.addEventListener("DOMContentLoaded", header);
/******/ })()
;